import { PACK_HASH } from '@app-types/home-pack';

import { partials } from '@helpers/partials';

import { PlanTypeId } from '@constants/plan';

export function getPackConfig() {
    return packConfig;
}
export type PackConfigType = {
    pageTitle: string;
    legalNoticesCeUrl: string;
    faqCeUrl: string;
    categoryToShow: PlanTypeId;
    slugProduct?: 'fai_categories_samsung';
    descriptiveTitle?: string;
    titleTicketBlock?: string;
    timelineToShow?: string;
};

const packConfig: { [key in PACK_HASH]: PackConfigType } = {
    [PACK_HASH.SMART_TV]: {
        pageTitle: 'Sélectionnez votre TV',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_SMART_TV,
        categoryToShow: PlanTypeId.FAI_SMART_TV,
        descriptiveTitle: 'Nos box + TV',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0TV',
        timelineToShow: 'mixte/zone_panier_bbox_smart_tv_1',
    },
    [PACK_HASH.GAMING]: {
        pageTitle: 'Sélectionnez votre console',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_GAMING,
        categoryToShow: PlanTypeId.FAI_GAMING,
        descriptiveTitle: 'Nos box + Xbox',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0Xbox',
        timelineToShow: 'checkout/indiana/bloc-reception',
    },
    [PACK_HASH.PS5]: {
        pageTitle: 'Sélectionnez votre console',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_GAMING_PS5,
        categoryToShow: PlanTypeId.FAI_GAMING,
        descriptiveTitle: 'Nos box + PS5',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0PS5',
        timelineToShow: 'checkout/indiana/bloc-reception',
    },
    [PACK_HASH.VIDEOPROJECTOR]: {
        pageTitle: 'Sélectionnez votre Vidéoprojecteur',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_SMART_TV,
        categoryToShow: PlanTypeId.FAI_VIDEOPROJECTOR,
        descriptiveTitle: 'Nos box + vidéoprojecteurs',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0vidéoprojecteur',
        timelineToShow: 'mixte/zone_panier_bbox_smart_tv_1',
    },
    [PACK_HASH.TABLET]: {
        pageTitle: 'Sélectionnez votre Tablette',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_SMART_TV,
        categoryToShow: PlanTypeId.FAI_TABLET,
        descriptiveTitle: 'Nos box + tablettes',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0tablette',
        timelineToShow: 'ec/zone_panier_bbox_tablette',
    },
    [PACK_HASH.IPAD]: {
        pageTitle: 'Sélectionnez votre iPad',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_TABLET,
        categoryToShow: PlanTypeId.FAI_TABLET,
        descriptiveTitle: 'Nos box + iPad',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0iPad',
        timelineToShow: 'ec/zone_panier_bbox_tablette',
    },
    [PACK_HASH.SMART_MONITOR]: {
        pageTitle: 'Sélectionnez votre Smart Monitor',
        legalNoticesCeUrl: '',
        faqCeUrl: partials.FAQ.PACK_SMART_TV,
        categoryToShow: PlanTypeId.FAI_SMART_MONITOR,
        descriptiveTitle: 'Nos box + Smart Monitors',
        titleTicketBlock: 'Découvrez le prix de votre offre box\u00A0+\u00A0Smart Monitor',
        timelineToShow: 'mixte/zone_panier_bbox_smart_tv_1',
    },
};
